<section>
  <div
    class="w-full py-3 flex align-items-center justify-content-between border-bottom-1 border-bottom-solid mb-3"
    [style]="{ 'border-color': 'var(--primary-gray)' }"
  >
    <h2 class="text-xl font-semibold" data-clarity-unmask="true">{{ title }}</h2>
    <p-button icon="pi pi-times" [rounded]="true" [text]="true" size="small" [disabled]="saving" (onClick)="closeDialog()" data-clarity-unmask="true"></p-button>
  </div>
</section>

<section>
  <form [formGroup]="form" (ngSubmit)="save()">
    <div class="form-rows">
      <div class="form-row">
        <label for="lectureGroupName" class="form-row__label">Nazwa grupy</label>
        <div class="form-row__control">
          <input id="lectureGroupName" type="text" pInputText formControlName="name" placeholder="Nazwa grupy" maxlength="200" />
          <small class="error-message" *ngIf="getErrorMessage('name') as error">{{ error }}</small>
        </div>
      </div>

      <div class="form-row">
        <label for="lectureGroupExam" class="form-row__label">Kategoria</label>
        <div class="form-row__control">
          <p-dropdown
            inputId="lectureGroupExam"
            styleClass="w-full"
            [options]="examCategoryOptions"
            formControlName="examGuid"
            placeholder="wybierz"
            appendTo="body"
            [loading]="loadingOptions"
          ></p-dropdown>
          <small class="error-message" *ngIf="getErrorMessage('examGuid') as error">{{ error }}</small>
        </div>
      </div>

      <div class="form-row">
        <label for="lectureGroupLeader" class="form-row__label">Prowadzący</label>
        <div class="form-row__control">
          <p-dropdown
            *ngIf="canManageGroups; else leaderReadOnly"
            inputId="lectureGroupLeader"
            styleClass="w-full"
            [options]="leaderOptions"
            formControlName="leaderEmployeeGuid"
            placeholder="Instruktor lub wykładowca (opcjonalnie)"
            [showClear]="true"
            emptyMessage="Brak instruktorów i wykładowców - dodasz ich w zakładce Pracownicy"
            appendTo="body"
          ></p-dropdown>
          <ng-template #leaderReadOnly>
            <span>{{ group?.leaderName || '—' }}</span>
          </ng-template>
          <small class="text-gray-500" *ngIf="canManageGroups">Prowadzący widzi grupę i jej kursantów i uruchamia jej wykłady.</small>
        </div>
      </div>

      <div class="form-row">
        <label for="lectureGroupStudents" class="form-row__label">Przypisani kursanci</label>
        <div class="form-row__control">
          <p-multiSelect
            inputId="lectureGroupStudents"
            styleClass="custom-multiselect w-full"
            [options]="studentOptions"
            formControlName="studentGuids"
            optionLabel="label"
            optionValue="value"
            placeholder="wybierz"
            [filter]="true"
            filterBy="label,name"
            filterPlaceHolder="Szukaj kursanta"
            emptyFilterMessage="Nie znaleziono kursanta"
            emptyMessage="Brak aktywnych kursantów"
            selectedItemsLabel="Wybrano: {0}"
            [maxSelectedLabels]="3"
            [showToggleAll]="true"
            appendTo="body"
            [loading]="loadingOptions"
          >
            <ng-template let-student pTemplate="item">
              <div class="flex flex-column">
                <span>{{ student.label }}</span>
                <small class="text-gray-500" *ngIf="student.name">{{ student.name }}</small>
              </div>
            </ng-template>
          </p-multiSelect>
        </div>
      </div>
    </div>

    <div class="flex pt-4 justify-content-end gap-3">
      <p-button label="Anuluj" [outlined]="true" [disabled]="saving" (onClick)="closeDialog()" data-clarity-unmask="true"></p-button>
      <p-button
        *ngIf="readonly && canManageGroups"
        label="Przywróć grupę"
        icon="pi pi-replay"
        [loading]="saving"
        (onClick)="restore()"
        data-clarity-unmask="true"
      ></p-button>
      <p-button
        *ngIf="!readonly"
        type="submit"
        [label]="group ? 'Zapisz zmiany' : 'Utwórz grupę'"
        [loading]="saving"
        [disabled]="loadingOptions"
        data-clarity-unmask="true"
      ></p-button>
    </div>
  </form>
</section>
